module.exports = __webpack_public_path__ + "assets/images/novasports_extra4.1bc78d8282e9a2fe53ecf3189d69d6cb.png";